import React, { useMemo } from "react";
import HeaderDesktop from "./HeaderDesktop";
import HeaderMobile from "./Mobile/HeaderMobile";
import useDynamicMediaQuery from "../../hooks/useDynamicMediaQuery";

const Header = (props) => {
	const { externalLinksJson, headerLabelsJson, menuJson } = props;
	const externalLinks = useMemo(() => JSON.parse(externalLinksJson), [externalLinksJson]);
	const labels = useMemo(() => JSON.parse(headerLabelsJson), [headerLabelsJson]);
	const menuLinks = useMemo(() => JSON.parse(menuJson), [menuJson]);
	const storeLink = externalLinks['store'] ?? null;

	// $nav-breakpoint
	const isDesktop = useDynamicMediaQuery(1024 + 180);

	return <>
		{isDesktop ? (
			<HeaderDesktop menu={menuLinks} storeLink={storeLink} labels={labels} />
		
		) : (
			<HeaderMobile menu={menuLinks} storeLink={storeLink} externalLinks={externalLinks} labels={labels} />
		)}
	</>
};

export default Header;
